import { createSlice } from "@reduxjs/toolkit";
import { EventEmpty } from "../emptyStates/Event";

export const eventSlice = createSlice({
  name: "event",
  initialState: EventEmpty,
  reducers: {
    ModifyEvent: (state, action) => ({ ...state, ...action.payload }),
    NewEvent: (_, action) => action.payload,
    ResetEvent: () => EventEmpty,
  },
});

export const { NewEvent, ModifyEvent, ResetEvent } = eventSlice.actions;


